import React from 'react';
import { Routes, Route, Link } from "react-router-dom";
//import { useNavigate } from "react-router-dom";
//import ReactDOM from "react-dom/client";
//import logo from './logo.svg';
import {
  Navbar,
  NavDropdown,
  Nav,
  Col,
  Container,
  Row,
} from 'react-bootstrap';
//import { Outlet, Link } from "react-router-dom";

//import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';

import MP_STANDARD from './routes/ecu/mp_standard'
import MP_CAN_LOGGER from './routes/ecu/mp_CanLogger'
import MP_CAN_DEMO from './routes/ecu/mp_CanDemo'
import MP_CALIBCONV from './routes/ecu/mp_CalibConv'
import MP_ENERGYREFORM from './routes/ecu/mp_EnergyReform'
import MP_NEUTRO from './routes/ecu/mp_Neutro'
import MP_DI60CUSTOM from './routes/ecu/mp_DI60Custom'

import Demo1 from './routes/demo1' 
import Demo2 from './routes/demo2'
import Login from './routes/login' 
import { ResetPasswordWrapper } from './routes/resetPassword' 
import Logout from './routes/logout' 

import AuthService from './services/auth-service';
//import Register from './routes/register';
import ErrorCodeList from './routes/ErrorCodeList';
import EcuList from './routes/EcuList';
import { EcuCalibComponentWrapper } from './routes/EcuCalib';
import { EcuDetailsComponentWrapper } from './routes/EcuDetails';

import { ServiceUserListComponentWrapper } from './routes/ServiceUserList';
import { SoftwareToolListComponentWrapper } from './routes/SoftwareToolList';
import { SoftwareFwListComponentWrapper } from './routes/SoftwareFwList';
import { ServiceUnlockCodeListComponentWrapper } from './routes/ServiceUnlockCodeList';
import ServiceUserMap from './routes/ServiceUserMap';

import "leaflet/dist/leaflet.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { ServiceUserDetailsComponentWrapper } from './routes/ServiceUserDetails';
import { ComputerAddComponentWrapper } from './routes/ComputerAdd';
import { ServiceUserAddComponentWrapper } from './routes/ServiceUserAdd';
import { ComputerVerifyComponentWrapper } from './routes/ComputerVerify';
import { ComputerListComponentWrapper } from './routes/ComputerList';
import EcuDiagChart, { EcuDiagChartComponentWrapper } from './routes/EcuDiagChart';
import { Button } from 'react-bootstrap';
import { Stack } from '@mui/material';
import utils from './utils';
import UserAuthRequired from './comp/gen/UserAuthRequired';
import LoadingSpinner from './comp/gen/LoadingSpinner';
import AppDocuPage from './routes/AppDocuPage';
import AppDocuActivityPage from './routes/AppDocuActivityPage';
import AppDocuActivityStatsPage from './routes/AppDocuActivityStatsPage';

// ****************************************************************************


function UtilsPage({ authStatus }) {
  if (!authStatus.completed) return <LoadingSpinner />
  if (authStatus.user === null) return <UserAuthRequired notlogged />
  if (utils.userHasRoleGuest(authStatus.user)) return <UserAuthRequired notallowed />

  const buttonConfig = [
    { role: "USER", to: "/mp/standard", label: "MP Standard" },
    { role: "ENERGYREF", to: "/mp/EnergyReform", label: "Fix Energy Reform" },
    { role: "NEUTRO", to: "/mp/Neutro", label: "Fix MP48 Client" },
    { role: "DI60CUSTOM", to: "/mp/DI60Custom", label: "DI60 Custom" },
    { role: "CALCONV", to: "/mp/CalibConv", label: "Calib Converter" },
    { role: "CANLOG", to: "/mp/CanLogger", label: "CAN Logger" },
    { role: "ADMIN", to: "/mp/CanDemo", label: "CAN Demo" },
  ];

  return (
    <Container className="mt-4">
      <Row>
        <Col md={3}>
          <Stack spacing={2} sx={{ mt: 4, px: 2 }}>
            <h1 className="mb-3 text-start">UTILS</h1>
            {buttonConfig.map((btn, index) => {
              if (utils.userHasRole(authStatus.user, btn.role)) {
                return (
                  <Button
                    as={Link}
                    to={btn.to}
                    variant="primary"
                    key={index} >{btn.label}</Button>
                );
              }
              return null;
            })}
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}

function MainHome(props) { return (<>Select an option from the top menu.</>) }

function AppNavBar(props) {
  var show = {
    utils_page: false,
    ecu_list: false,    
    user_list: false,
    gasspecialist_user_list: false,
    reseller_user_list: false,
    admin_user_list: false,
    user_computer_list: false,
    admin_computer_list: false,    
    last_minutes_map: false,
    unlock_codes: false,
    user_software_list: false,
    admin_software_list: false,
  }

  if (props.user) {
    
    show.utils_page = !utils.userHasRoleGuest(props.user)
    show.ecu_list = utils.userHasRoleAdmin(props.user) // questo controlla anche che is_admin sia true
    
    if (props.user.is_admin) {      
      show.unlock_codes = true
      
      show.user_list = true
      show.gasspecialist_user_list = true
      show.reseller_user_list = true
      show.admin_user_list = true
      
      show.admin_computer_list = true      
      show.admin_software_list = true
    } else {
      show.user_software_list = true ////////// TODO: METTERE A FALSE
      show.user_computer_list = true ///////// PER TUTTI VISIBILE !!!!!!!!!!!!!!!!!!
    }

    if (props.user.accesso_keygen) {
      show.unlock_codes = true
    }

    switch (props.user.id) { 
      default:
        break;
      case 1: // mcanta
      case 1150:  // falciano
      case 28937: // teo
      case 37944: // geschi
        show.last_minutes_map = true
        break;
    }
  }
  
  return (
    <Navbar collapseOnSelect expand="xl" bg="dark" variant="dark">
      <Container fluid>
        <Navbar.Toggle />
        <Navbar.Brand as={Link} to={"/computer/list"}>ServiceApplications.net</Navbar.Brand>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto" style={{ whiteSpace: 'nowrap' }}>
            { props.user && (
              <>
                {show.utils_page && <Nav.Link as={Link} to="/utils">UTILS</Nav.Link>}                
                {show.ecu_list && <Nav.Link as={Link} to={"/ecu/list"}>ECU LIST</Nav.Link>}

                {show.user_list && (
                  <NavDropdown title="SERVICE USER" id="basic-nav-dropdown">
                    <NavDropdown.Item as={Link} to={"/service/user/list"}>ALL</NavDropdown.Item>
                    {show.gasspecialist_user_list && (<NavDropdown.Item as={Link} to={"/service/user/list/gasspecialists"}>Gas Specialists</NavDropdown.Item>)}
                    {show.reseller_user_list && (<NavDropdown.Item as={Link} to={"/service/user/list/resellers"}>Resellers</NavDropdown.Item>)}
                    {show.admin_user_list && (<NavDropdown.Item as={Link} to={"/service/user/list/admins"}>Admins</NavDropdown.Item>)}
                  </NavDropdown>
                )}

                {show.user_computer_list && <Nav.Link as={Link} to={"/computer/list"}>COMPUTERS</Nav.Link>}
                {show.admin_computer_list && (
                  <NavDropdown title="COMPUTERS" id="basic-nav-dropdown">
                    <NavDropdown.Item as={Link} to={"/computer/list"}>ALL</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to={"/computer/list/gasspecialists"}>Gas Specialists</NavDropdown.Item>
                  </NavDropdown>
                )}
                
                {show.unlock_codes && <Nav.Link as={Link} to={"/service/unlock/code/list"}>UNLOCK CODES</Nav.Link>}                
                {show.last_minutes_map && <Nav.Link as={Link} to={"/service/user/map"}>LAST 30 MINUTES</Nav.Link>}
                
                {show.user_software_list && <Nav.Link as={Link} to={"/software/tool/list/last"}>SOFTWARE LIST</Nav.Link>}
                {show.admin_software_list && (
                  <NavDropdown title="SOFTWARE" id="basic-nav-dropdown">
                    <NavDropdown.Item disabled>FIRMWARE</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to={"/software/fw/list/last"}>LAST</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to={"/software/fw/list/all"}>ALL</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item disabled>TOOLS</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to={"/software/tool/list/last"}>LAST</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to={"/software/tool/list/all"}>ALL</NavDropdown.Item>
                  </NavDropdown>
                )}
              </>
            )}
          </Nav>
          <Nav className="ms-auto" style={{ whiteSpace: 'nowrap' }}>
            { props.user === null ? (
              <>
                <Nav.Link as={Link} to={"/service/user/login"}>LOGIN</Nav.Link>
                {/* <Nav.Link as={Link} to={"/register"}>REGISTER</Nav.Link> */}
              </>
            ) : (
              <>
                <Nav.Link as={Link} to={"/service/user/details/" + props.user.id}>Signed in as {props.user.first_name}</Nav.Link>
                <Nav.Link as={Link} to={"/logout"}>LOGOUT</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default class App extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = {
      authStatus: {
        user: null,
        completed: false,
      }
    };    
  }  
  componentDidMount() {
    this.validateUser()    
  }
  validateUser() {
    this.setState({
      authStatus: {
        user: /*this.state.authStatus.user*/ null,
        completed: false,
      }
    })
    AuthService.ValidateServiceUserToken().then(data => {
      if (data.is_valid) {
        console.log("validate ok")
        //console.log(data.user)
        this.setState({
          authStatus: {
            user: data.user,
            completed: true,
          }
        })
      } else {
        console.log("validate error: " + data.message)
        this.setState({
          authStatus: {
            user: null,
            completed: true,
          }
        })
      }
    }).catch(error => {
      console.log("validate throw")
      console.log(error)
      this.setState({
        authStatus: {
          user: null,
          completed: true,
        }
      })
    })
  }  
  loginHandler() {
    console.log("loginHandler")
    this.validateUser()
  }
  resetPasswordHandler() {
    console.log("resetPasswordHandler")
    //this.validateUser()
  }
  logoutHandler() {
    console.log("logoutHandler")
    this.setState({
      authStatus: {
        user: null,
        completed: true,
      }
    })
  }
  registerHandler() {
    console.log("registerHandler")
  }
  render() {
    const navbarHeight = '84px';
    const commonProps = { authStatus: this.state.authStatus, navbarHeight };
    const routesConfig = [
      { path: "/", element: <MainHome /> },
      { path: "*", element: <MainHome /> },
      { path: "/mp/standard", element: <MP_STANDARD /> },
      { path: "/mp/CanLogger", element: <MP_CAN_LOGGER /> },
      { path: "/mp/CanDemo", element: <MP_CAN_DEMO /> },
      { path: "/mp/CalibConv", element: <MP_CALIBCONV /> },
      { path: "/mp/EnergyReform", element: <MP_ENERGYREFORM /> },
      { path: "/mp/Neutro", element: <MP_NEUTRO /> },
      { path: "/mp/DI60Custom", element: <MP_DI60CUSTOM /> },
      { path: "/demo1", element: <Demo1 /> },
      { path: "/demo2", element: <Demo2 /> },
      { path: "/dtc/code/list", element: <ErrorCodeList /> },
      { path: "/ecu/list", element: <EcuList /> },
      { path: "/ecu/details/:ecu_id", element: <EcuDetailsComponentWrapper /> },
      { path: "/ecu/diag/buffer/:diag_buffer_id", element: <EcuDiagChartComponentWrapper /> },
      { path: "/ecu/calib/:calib_id", element: <EcuCalibComponentWrapper /> },
      { path: "/ecu/calib/:calib_id/:comp_calib_id", element: <EcuCalibComponentWrapper /> },
      // http://localhost:3000/software/fw/list/last 
      // http://localhost:3000/software/fw/list/all 
      { path: "/software/fw/list/:mode", element: <SoftwareFwListComponentWrapper /> },
      // http://localhost:3000/software/fw/list/last/selector/lovato
      { path: "/software/fw/list/:mode/selector/:selector", element: <SoftwareFwListComponentWrapper /> },
      // http://localhost:3000/software/tool/list/last
      // http://localhost:3000/software/tool/list/all
      { path: "/software/tool/list/:mode", element: <SoftwareToolListComponentWrapper /> },
      // http://localhost:3000/software/tool/list/last/selector/cantool2_admin
      { path: "/software/tool/list/:mode/selector/:selector", element: <SoftwareToolListComponentWrapper /> },
      // http://localhost:3000/software/tool/list/last/group/DI
      { path: "/software/tool/list/:mode/group/:group", element: <SoftwareToolListComponentWrapper /> },
      { path: "/service/user/details/:user_id", element: <ServiceUserDetailsComponentWrapper /> },
      { path: "/service/user/add/*", element: <ServiceUserAddComponentWrapper /> },
      { path: "/computer/add/*", element: <ComputerAddComponentWrapper /> },
      { path: "/computer/verify/*", element: <ComputerVerifyComponentWrapper /> },
      // COMPUTER LIST
      { path: "/computer/list", element: <ComputerListComponentWrapper /> },
      { path: "/computer/list/gasspecialists", element: <ComputerListComponentWrapper gasspecialists="true" /> },
      { path: "/computer/list/reseller/:reseller_id", element: <ComputerListComponentWrapper /> },
      { path: "/computer/list/user/:user_id", element: <ComputerListComponentWrapper /> },
      { path: "/computer/list/code/:user_code", element: <ComputerListComponentWrapper /> },
      { path: "/computer/list/code/:user_code/license", element: <ComputerListComponentWrapper /> },
      { path: "/computer/list/selector/:selector", element: <ComputerListComponentWrapper /> },
      // UNLOCK CODE
      { path: "/service/unlock/code/list", element: <ServiceUnlockCodeListComponentWrapper /> },
      { path: "/service/unlock/code/list/:unlocker_id", element: <ServiceUnlockCodeListComponentWrapper /> },
      // SERVICE USER LIST
      { path: "/service/user/list", element: <ServiceUserListComponentWrapper /> },
      { path: "/service/user/list/:list_type", element: <ServiceUserListComponentWrapper /> },
      { path: "/service/user/map", element: <ServiceUserMap /> },
      { path: "/service/user/login", element: <Login loginHandler={this.loginHandler.bind(this)} /> },
      { path: "/service/user/reset/password", element: <ResetPasswordWrapper resetPasswordHandler={this.resetPasswordHandler.bind(this)} /> },
      { path: "/service/user/reset/password/:reset_code", element: <ResetPasswordWrapper resetPasswordHandler={this.resetPasswordHandler.bind(this)} /> },
      { path: "/logout", element: <Logout logoutHandler={this.logoutHandler.bind(this)} /> },
      { path: "/utils", element: <UtilsPage /> },
      { path: "/appdocu", element: <AppDocuPage /> },
      { path: "/appdocu/activity", element: <AppDocuActivityPage /> },
      { path: "/appdocu/activity/stats", element: <AppDocuActivityStatsPage /> },
    ];

    return (      
      <>
        <Container fluid>
          <Row>
            <AppNavBar user={this.state.authStatus.user} />
          </Row>
          <Row>
            <Col style={{  border: '0px solid yellow', paddingTop: "14px", height: `calc(100vh - ${navbarHeight})` }}>
              <Routes>
                {routesConfig.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={React.cloneElement(route.element, { ...commonProps })}
                  />
                ))}
              </Routes>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
